import { Navigate } from "react-router-dom";
import MainLayout from "../components/Layouts/MainLayout";
import Home from "../features/home/layout/Home";
import Survey from "../features/survey/layout/Survey";
import SurveyEnd from "../features/survey/layout/SurveyEnd";
import DoneSurveys from "../features/doneSurvey/layout/DoneSurveys";
import PendingSurveys from "../features/pendingSurvey/layout/PendingSurveys";


type PrivateRouteProps = {
  children: React.ReactNode;
};

const PrivateRoute: React.FC<PrivateRouteProps> = ({ children }) => {
    const token = localStorage.getItem('token');

  if (!token) {
    return <Navigate to="/login" />;
  }

  return <>{children}</>;
};

export const protectedRoutes = [
    {
        path: '/',
        element: (
            <PrivateRoute>
                <MainLayout />
            </PrivateRoute>
        ),
        children: [
            {
                path: '/',
                element: <Home />, 
                children: [
                    { path: '', element: <Navigate to="pending-surveys" replace /> }, 
                    { path: 'done-surveys', element: <DoneSurveys /> },
                    { path: 'pending-surveys', element: <PendingSurveys /> },
                ],
            },
            { path: 'survey/:idSurvey/:order', element: <Survey /> }, 
            { path: 'end-survey/:idSurvey/:order', element: <SurveyEnd /> }, 
        ],
    },
];

